import React, { useContext } from "react";
import { FirebaseContext } from "../../../FirebaseContext";
import { SelectionButton } from "../SelectionButton/"
// import characterCreationReference from '../characterCreationReference.json';
import './SelectClass.css';
import barbarianIcon from '../../../Images/classes/barbarian.svg';
import bardIcon from '../../../Images/classes/bard.svg';
import clericIcon from '../../../Images/classes/cleric.svg';
import druidIcon from '../../../Images/classes/druid.svg';
import fighterIcon from '../../../Images/classes/fighter.svg';
import monkIcon from '../../../Images/classes/monk.svg';
import paladinIcon from '../../../Images/classes/paladin.svg';
import rangerIcon from '../../../Images/classes/ranger.svg';
import rogueIcon from '../../../Images/classes/rogue.svg';
import sorcererIcon from '../../../Images/classes/sorcerer.svg';
import warlockIcon from '../../../Images/classes/warlock.svg';
import wizardIcon from '../../../Images/classes/wizard.svg';

export const SelectClass = () => {
    const { characterJSON, setCharacterJSON } = useContext(FirebaseContext);

    const selectingClass = (className) => {
        if (characterJSON.class === className) {
            // If the clicked class is already selected, deselect it by setting to an empty string
            setCharacterJSON(prevState => ({
                ...prevState,
                class: ''
            }));
        } else {
            // Otherwise, set the clicked class as the selected class
            setCharacterJSON(prevState => ({
                ...prevState,
                class: className
            }));
        }
    };

    const classes = [
        { name: 'Barbarian', icon: barbarianIcon, disabled: false },
        { name: 'Bard', icon: bardIcon, disabled: false },
        { name: 'Cleric', icon: clericIcon, disabled: false },
        { name: 'Druid', icon: druidIcon, disabled: false },
        { name: 'Fighter', icon: fighterIcon, disabled: false },
        { name: 'Monk', icon: monkIcon, disabled: false },
        { name: 'Paladin', icon: paladinIcon, disabled: false },
        { name: 'Ranger', icon: rangerIcon, disabled: false },
        { name: 'Rogue', icon: rogueIcon, disabled: false },
        { name: 'Sorcerer', icon: sorcererIcon, disabled: false },
        { name: 'Warlock', icon: warlockIcon, disabled: false },
        { name: 'Wizard', icon: wizardIcon, disabled: false }
    ];

    return (
        <div className="content-wrapper">
            <h2 className="character-heading">
                Choose a class:
            </h2>             
            <div className="character-grid">
                {classes.map((charClass, index) => (
                    <SelectionButton
                        key={charClass.name}
                        name={charClass.name}
                        icon={charClass.icon}
                        isSelected={characterJSON.class === charClass.name}
                        onClick={() => selectingClass(charClass.name)}
                        disabled={charClass.disabled}
                    />
                ))}
            </div>
        </div>
    );
};
